import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import ScrollToHash from "./components/ScrollToHash";
import HomePage from "./pages/HomePage";
import AllWatchesPage from "./pages/AllWatchesPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import OurServicesPage from "./pages/OurServicesPage";
import AboutPage from "./pages/AboutPage";
import BrandsPage from "./pages/BrandsPage";
import { useGet } from "./api/useApi";
import { API_ROUTES } from "./api/apiRoutes";
import "./App.css";

function App() {
  const [brandOptions, setBrandOptions] = useState([]);
  const [footerBrandOptions, setFooterBrandOptions] = useState([
    {
      name: "Rolex",
    },
    {
      name: "Audemars Piguet",
    },
    {
      name: "Patek Philippe",
    },
    {
      name: "Panerai",
    },
    {
      name: "Omega",
    },
    {
      name: "Cartier",
    },
  ]);

  // API Calls
  const { loading: loadingGetBrands } = useGet(API_ROUTES.BRAND.GET_OPTIONS, {
    executeOnMount: true,
    onSuccess: (data) => {
      const options = data?.value;
      setBrandOptions(options);
    },
    onError: (error) => {
      console.error("Error fetching brands:", error);
    },
  });

  return (
    <BrowserRouter>
      <ScrollToHash />
      <Navbar brandOptions={brandOptions} loadingBrandOptions={loadingGetBrands} />
      <Routes>
        <Route path="/" element={<HomePage brandOptions={brandOptions} />} />
        <Route
          path="/watches"
          element={<AllWatchesPage brandOptions={brandOptions} />}
        />
        <Route path="/brands" element={<BrandsPage />} />
        <Route path="/watches/:id" element={<ProductDetailPage />} />
        <Route path="/services" element={<OurServicesPage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
      <Footer brandOptions={footerBrandOptions} />
      <WhatsAppFloat />
    </BrowserRouter>
  );
}

export default App;
